import { render, staticRenderFns } from "./PButton.vue?vue&type=template&id=79e6072e&scoped=true&"
import script from "./PButton.vue?vue&type=script&lang=js&"
export * from "./PButton.vue?vue&type=script&lang=js&"
import style0 from "./PButton.vue?vue&type=style&index=0&id=79e6072e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e6072e",
  null
  
)

export default component.exports